import React from 'react';
import { createRoot } from "react-dom/client";
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import '../src/global.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/main.scss';
import{ Toaster } from 'react-hot-toast';

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<App />
			<Toaster/>
		</BrowserRouter>
	 </React.StrictMode>
	 ,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
